module.exports = __webpack_public_path__ + "c5fe47ea31699a584d0c4fd19e63512b.jpg";